import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import React from "react";

const ConfirmationAlert = ({
  open,
  close,
  handleConfirm,
  title,
  message,
  handleReject,
  className,
  confirmMessage,
  rejectMessage
}) => {
  return (
    <Dialog open={open} onClose={close} className={className}>
      {title && <DialogTitle>{title}</DialogTitle>}
      {message && (
        <DialogContent dividers>
          <DialogContentText className="modal-content-text">
            {message}
          </DialogContentText>
        </DialogContent>
      )}
      <DialogActions className="flex justify-between">
        <Button color='error' onClick={handleReject || close}>
          {rejectMessage || 'Cancel'}
        </Button>
        <Button color='error' className="font-bold" onClick={handleConfirm} autoFocus>
          {confirmMessage || 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationAlert;
